import {observer} from "mobx-react";
import React from "react";
import ModalPay from "@dropDesk/presentation/components/modals/modal_information";
import {useModalsSubscription} from "@dropDesk/presentation/pages/subscription/ui/modals/visible_modal_subscription";
import {useBetween} from "use-between";
import ModalMain from "@dropDesk/presentation/components/modals/modal_main";
import PayCreditCard from "@dropDesk/presentation/pages/subscription/ui/modals/pay_credit_card";
import PaySuccess from "@dropDesk/presentation/pages/subscription/ui/modals/pay_success";
import {PaymentSubscriptionEntity} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription_entity";
import {CompanyPaymentInfo} from "@dropDesk/domain/entities/company/company.entity";
import InputsPaymentInfo from "@dropDesk/presentation/pages/subscription/ui/checkout/payment_info";
import {RoutesSubscription} from "@dropDesk/presentation/pages/subscription/controller/subscription.controller";
import PaymentMethod from "@dropDesk/presentation/pages/subscription/ui/checkout/payment_type/payment_method";
import {CardEntity, TokenizeCardEntity} from "@dropDesk/domain/entities/payment_method/payment_method.entity";
import {TabsPayment} from "@dropDesk/domain/entities/payment_method/payment_method.enum";
import {ContentPaymentMethod} from "@dropDesk/presentation/pages/subscription/ui/modals/styled";
import CancelSubscription from "@dropDesk/presentation/pages/subscription/ui/modals/cancel_subscription";
import ReactiveSubscription from "@dropDesk/presentation/pages/subscription/ui/modals/reactive_subscription";
import ModalInformation from "@dropDesk/presentation/components/modals/modal_information";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";
import PayInfo from "src/presentation/pages/subscription/ui/modals/pay_info";
import {CompanyLogsEntity} from "@dropDesk/domain/entities/company/company_logs.entity";
import ViewLog from "@dropDesk/presentation/pages/subscription/ui/modals/view_log";
import ModalCancelLegacyPlan from "@dropDesk/presentation/components/modals/modal_information";
import RejectedPayCreditCard from "@dropDesk/presentation/pages/subscription/ui/modals/rejected_pay_credit_card";
import {PlanExtensionCatalogEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_catalog.entity";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";
import ExtensionTrialSuccess from "@dropDesk/presentation/pages/subscription/ui/modals/extension_trial_success";


const ModalsSubscription = observer(
    ({
         changePaymentMethod,
         payCreditCardSaved,
         loading,
         onClickDownloadInvoice,
         newSubscription,
         newPaymentInfo,
         onUpdatePaymentInfo,
         onSearchCNPJ,
         onSearchZipCode,
         onClickSavePaymentInfo,
         setActiveRoute,
         newTokenizeCard,
         onUpdateTokenizeCard,
         setActiveTabPayment,
         currentPayment,
         cardSaved,
         activeTabPayment,
         makePaymentMethod,
         cancellationReason,
         setCancellationReason,
         cancelSubscription,
         reactiveSubscription,
         logout,
         resetPaymentMethod,
         disposePaymentSubscription,
         oldSubscription,
         cancelFutureSubscription,
         downgradePlan,
         textDowngrade,
         log,
         hasErrorConnectSocket,
         hasErrorConnectSocketTemporary,
         handleReconnectSocket,
         loadingReconnect,
         onConfirmCancelExtension,
         onConfirmReactivateExtension,
         hasActiveExtensions,
         hasScheduledCancelExtensions,
     }: {
        changePaymentMethod: () => Promise<void>,
        payCreditCardSaved: () => Promise<void>,
        loading: boolean
        onClickDownloadInvoice: (payment: PaymentEntity) => void
        newSubscription: PaymentSubscriptionEntity
        newPaymentInfo: CompanyPaymentInfo
        onUpdatePaymentInfo: (paymentInfo: CompanyPaymentInfo) => void
        onSearchCNPJ: (document: string) => void,
        onSearchZipCode: (zipCode: string) => void,
        onClickSavePaymentInfo: () => void
        setActiveRoute: (route: RoutesSubscription) => void
        newTokenizeCard: TokenizeCardEntity | null
        onUpdateTokenizeCard: (newTokenizeCard: TokenizeCardEntity) => void
        setActiveTabPayment: (value: TabsPayment) => void
        currentPayment?: TabsPayment
        cardSaved?: CardEntity
        activeTabPayment: TabsPayment | null,
        makePaymentMethod: () => void
        cancellationReason?: string;
        setCancellationReason: (cancellationReason?: string) => void
        cancelSubscription: () => void
        reactiveSubscription: () => void
        logout: () => Promise<void>
        resetPaymentMethod: () => void;
        disposePaymentSubscription: () => void
        oldSubscription?: PaymentSubscriptionEntity
        cancelFutureSubscription: () => void
        downgradePlan: () => void
        textDowngrade: string
        log?: CompanyLogsEntity
        hasErrorConnectSocket: boolean
        hasErrorConnectSocketTemporary: boolean
        loadingReconnect: boolean
        handleReconnectSocket: (payment: PaymentEntity) => void
        onConfirmCancelExtension: (extensionId: string) => void
        onConfirmReactivateExtension: (extensionId: string) => void
        hasActiveExtensions: boolean
        hasScheduledCancelExtensions: boolean

    }) => {
        const {
            visibleModalPay, setVisibleModalPay,
            visibleModalDisplayDataPix, setVisibleModalDisplayDataPix,
            visibleModalDisplayBoleto, setVisibleModalDisplayBoleto,
            visibleModalProcessingCreditCardPayment, setVisibleModalProcessingCreditCardPayment,
            visibleModalPaymentSuccess, setVisibleModalPaymentSuccess,
            visibleModalChangePaymentInfo, setVisibleModalChangePaymentInfo,
            visibleModalChangePaymentMethod, setVisibleModalChangePaymentMethod,
            visibleModalReactiveSubscription, setVisibleModalReactiveSubscription,
            visibleModalCancelSubscription, setVisibleModalCancelSubscription,
            visibleModalLogout, setVisibleModalLogout,
            visibleModalCancelFutureSubscription, setVisibleModalCancelFutureSubscription,
            visibleModalDowngrade, setVisibleModalDowngrade,
            visibleModalViewLog, setVisibleModalViewLog,
            visibleModalRejectedCreditCardPayment, setVisibleModalRejectedCreditCardPayment,
            visibleModalCancelExtension, setVisibleModalCancelExtension,
            visibleModalReactivateExtension, setVisibleModalReactivateExtension,
            visibleModalExtensionTrialSuccess, setVisibleModalExtensionTrialSuccess,
        } = useBetween(useModalsSubscription);

        return (
            <>
                <ModalPay
                    open={visibleModalPay.visible}
                    onRequestClose={() => {
                        setVisibleModalPay({visible: false, isTrial: false});
                    }}
                    textHeaderModal={'Realizar pagamento'}
                    textButton={visibleModalPay.isTrial ? 'Ativar com Cartão' : 'Pagar'}
                    onRequestSave={async () => {
                        payCreditCardSaved();
                        setVisibleModalPay({visible: false, isTrial: false});
                    }}
                    nameIcon={ICONS_DROPDESK.info}
                    sizeIcon={130}
                    textInformation={
                        visibleModalPay.isTrial
                            ? 'Deseja ativar a extensão com o cartão de crédito salvo? O período gratuito será aplicado e a cobrança ocorrerá somente após o término do trial.'
                            : 'Deseja realmente realizar o pagamento com este cartão selecionado?'
                    }
                    loading={loading}
                />

                {log && <ModalMain
                    open={visibleModalViewLog}
                    onRequestClose={() => setVisibleModalViewLog(false)}
                    width={600}
                    renderComponent={
                        <ViewLog
                            log={log}
                        />
                    }
                />}

                {visibleModalDisplayDataPix.payment && <ModalMain
                    open={visibleModalDisplayDataPix.visible}
                    onRequestClose={() => setVisibleModalDisplayDataPix({visible: false})}
                    width={700}
                    renderComponent={
                        <PayInfo
                            payment={visibleModalDisplayDataPix.payment!}
                            labelNewPeriod={visibleModalDisplayDataPix.payment.periodFormatted}
                            disposePaymentSubscription={disposePaymentSubscription}
                            onClickDownloadInvoice={onClickDownloadInvoice}
                            isPix={true}
                            hasErrorConnectSocket={hasErrorConnectSocket}
                            hasErrorConnectSocketTemporary={hasErrorConnectSocketTemporary}
                            handleReconnectSocket={handleReconnectSocket}
                            loadingReconnect={loadingReconnect}
                        />
                    }
                />}

                {visibleModalDisplayBoleto.payment && <ModalMain
                    open={visibleModalDisplayBoleto.visible}
                    onRequestClose={() => setVisibleModalDisplayBoleto({visible: false})}
                    width={700}
                    renderComponent={
                        <PayInfo
                            payment={visibleModalDisplayBoleto.payment!}
                            onClickDownloadInvoice={onClickDownloadInvoice}
                            labelNewPeriod={visibleModalDisplayBoleto.payment.periodFormatted}
                            disposePaymentSubscription={disposePaymentSubscription}
                            isPix={false}
                            hasErrorConnectSocket={hasErrorConnectSocket}
                            hasErrorConnectSocketTemporary={hasErrorConnectSocketTemporary}
                            handleReconnectSocket={handleReconnectSocket}
                            loadingReconnect={loadingReconnect}
                        />
                    }
                />}

                {visibleModalProcessingCreditCardPayment.payment && <ModalMain
                    open={visibleModalProcessingCreditCardPayment.visible}
                    onRequestClose={() => setVisibleModalProcessingCreditCardPayment({visible: false})}
                    width={600}
                    renderComponent={
                        <PayCreditCard
                            value={visibleModalProcessingCreditCardPayment.payment.value}
                            planName={visibleModalProcessingCreditCardPayment?.payment?.planDescription ?? ''}
                        />
                    }
                />}

                {visibleModalRejectedCreditCardPayment.payment && <ModalMain
                    open={visibleModalRejectedCreditCardPayment.visible}
                    onRequestClose={() => setVisibleModalRejectedCreditCardPayment({visible: false})}
                    width={600}
                    renderComponent={
                        <RejectedPayCreditCard
                            value={visibleModalRejectedCreditCardPayment.payment.value}
                            planName={visibleModalRejectedCreditCardPayment.payment.planDescription}
                        />
                    }
                />}

                <ModalMain
                    open={visibleModalPaymentSuccess}
                    onRequestClose={() => setVisibleModalPaymentSuccess(false)}
                    width={600}
                    renderComponent={
                        <PaySuccess/>
                    }
                />

                <ModalMain
                    open={visibleModalChangePaymentInfo}
                    onRequestClose={() => setVisibleModalChangePaymentInfo(false)}
                    width={600}
                    renderComponent={
                        <InputsPaymentInfo
                            isEditExternal={true}
                            backPreviousScreenExternalScreen={() => setVisibleModalChangePaymentInfo(false)}
                            newPaymentInfo={newPaymentInfo}
                            onUpdate={onUpdatePaymentInfo}
                            onSearchCNPJ={onSearchCNPJ}
                            onSearchZipCode={onSearchZipCode}
                            onClickSavePaymentInfo={onClickSavePaymentInfo}
                            setActiveRoute={setActiveRoute}
                            loading={loading}
                            canReturnPaymentType={false}
                            handleEditPaymentInfo={() => {
                            }}
                            fromExtension={false}
                        />
                    }
                />

                <ModalMain
                    open={visibleModalChangePaymentMethod}
                    onRequestClose={() => setVisibleModalChangePaymentMethod(false)}
                    width={700}
                    renderComponent={
                        <ContentPaymentMethod>
                            <PaymentMethod
                                isEditExternal={true}
                                backPreviousScreenExternalScreen={() => setVisibleModalChangePaymentMethod(false)}
                                newTokenizeCard={newTokenizeCard}
                                onUpdateTokenizeCard={onUpdateTokenizeCard}
                                pay={changePaymentMethod}
                                setActiveTabPayment={setActiveTabPayment}
                                onClickPayCreditCardSaved={() => setVisibleModalPay({visible: true, isTrial: false})}
                                loading={loading}
                                currentPayment={currentPayment}
                                cardSaved={cardSaved}
                                activeTabPayment={activeTabPayment}
                                makePaymentMethod={makePaymentMethod}
                                resetPaymentMethod={resetPaymentMethod}
                                fromExtension={false}
                            />
                        </ContentPaymentMethod>
                    }
                />

                <ModalMain
                    open={visibleModalCancelSubscription}
                    onRequestClose={() => setVisibleModalCancelSubscription(false)}
                    width={600}
                    renderComponent={
                        <CancelSubscription
                            loading={loading}
                            onRequestClose={() => setVisibleModalCancelSubscription(false)}
                            cancellationReason={cancellationReason}
                            setCancellationReason={setCancellationReason}
                            hasActiveExtensions={hasActiveExtensions}
                            onRequestSave={() => {
                                cancelSubscription();
                                setVisibleModalCancelSubscription(false);
                            }}
                        />
                    }
                />

                <ModalMain
                    open={visibleModalReactiveSubscription}
                    onRequestClose={() => setVisibleModalReactiveSubscription(false)}
                    width={600}
                    renderComponent={
                        <ReactiveSubscription
                            loading={loading}
                            onRequestClose={() => setVisibleModalReactiveSubscription(false)}
                            hasScheduledCancelExtensions={hasScheduledCancelExtensions}
                            onRequestSave={() => {
                                reactiveSubscription();
                                setVisibleModalReactiveSubscription(false);
                            }}
                        />
                    }
                />

                <ModalInformation
                    open={visibleModalLogout}
                    onRequestClose={() => {
                        setVisibleModalLogout(false);
                    }}
                    textHeaderModal={'Sair do sistema'}
                    textButton={'Sair'}
                    onRequestSave={async () => {
                        await logout();
                        setVisibleModalLogout(false);
                    }}
                    nameIcon={'logout'}
                    sizeIcon={130}
                    textInformation={`Deseja realmente sair do sistema?`}
                    loading={false}
                />

                {oldSubscription &&

                    <ModalInformation
                        open={visibleModalCancelFutureSubscription}
                        onRequestClose={() => {
                            setVisibleModalCancelFutureSubscription(false);
                        }}
                        textHeaderModal={'Desfazer troca de plano'}
                        textButton={'Confirmar'}
                        onRequestSave={() => {
                            cancelFutureSubscription();
                            setVisibleModalCancelFutureSubscription(false);
                        }}
                        nameIcon={ICONS_DROPDESK.info}
                        sizeIcon={130}
                        textInformation={`Deseja realmente desfazer a mudança de plano? Ao desfazer será restaurada a assinatura ${oldSubscription.planName}.`}
                        loading={false}
                    />}

                <ModalInformation
                    open={visibleModalDowngrade}
                    onRequestClose={() => {
                        setVisibleModalDowngrade(false);
                    }}
                    textHeaderModal={'Downgrade de plano'}
                    textButton={'Confirmar'}
                    onRequestSave={() => {
                        downgradePlan();
                        setVisibleModalDowngrade(false);
                    }}
                    nameIcon={ICONS_DROPDESK.info}
                    sizeIcon={130}
                    textInformation={textDowngrade}
                    loading={false}
                />

                <ModalInformation
                    open={visibleModalCancelExtension.visible}
                    onRequestClose={() => {
                        setVisibleModalCancelExtension({visible: false, extension: null});
                    }}
                    textHeaderModal={'Cancelar extensão'}
                    textButton={'Confirmar cancelamento'}
                    onRequestSave={async () => {
                        if (visibleModalCancelExtension.extension?.idExtension) {
                            onConfirmCancelExtension(visibleModalCancelExtension.extension.idExtension);
                        }
                        setVisibleModalCancelExtension({visible: false, extension: null});
                    }}
                    nameIcon={ICONS_DROPDESK.warning}
                    iconColor={SharedColors.errorOnPrimary}
                    sizeIcon={115}
                    textInformation={`A extensão continuará ativa até o fim do ciclo de cobrança atual. Após esse período, ela será desativada e não haverá mais cobranças.`}
                    loading={loading}
                    isActionDelete={true}
                />

                <ModalInformation
                    open={visibleModalReactivateExtension.visible}
                    onRequestClose={() => {
                        setVisibleModalReactivateExtension({visible: false, extension: null});
                    }}
                    textHeaderModal={'Reativar extensão'}
                    textButton={'Reativar'}
                    onRequestSave={async () => {
                        if (visibleModalReactivateExtension.extension?.idExtension) {
                            onConfirmReactivateExtension(visibleModalReactivateExtension.extension.idExtension);
                        }
                        setVisibleModalReactivateExtension({visible: false, extension: null});
                    }}
                    nameIcon={ICONS_DROPDESK.check}
                    sizeIcon={115}
                    textInformation={`O cancelamento agendado será removido e a extensão continuará ativa normalmente no próximo ciclo de cobrança.`}
                    loading={loading}
                    isActionDelete={false}
                />

                {visibleModalExtensionTrialSuccess.simulate && <ModalMain
                    open={visibleModalExtensionTrialSuccess.visible}
                    onRequestClose={() => setVisibleModalExtensionTrialSuccess({visible: false, simulate: null})}
                    width={600}
                    renderComponent={
                        <ExtensionTrialSuccess simulate={visibleModalExtensionTrialSuccess.simulate}/>
                    }
                />}

            </>
        )
    })
export default ModalsSubscription;
